export default __webpack_public_path__ + "static/media/login.7ca4de9d.svg";